module.exports = "<yeti-modal-dialog [modalHeader]=\"headerText\" [modalComponent]=\"this\" [showClose]=\"false\" [allowBackdropClose]=\"false\" [allowEscapeClose]=\"false\">\r\n    <div class=\"yeti-modal-body\"><yeti-loading-icon></yeti-loading-icon></div>\r\n</yeti-modal-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/modal-dialog/loading-modal/loading-modal.html
// module id = 667
// module chunks = 0